import "../../pages/Article.scss";
import "./article-dark.scss";
import ArticleService from "../../services/ArticleService";
import RenderBodyParts from "./RenderBodyParts";
import AuthorService from "../../services/AuthorService";
import FavouriteButton from "../ui/functional/FavouriteButton";
import ShareButton from "../ui/functional/ShareButton";
import {useContext, useEffect, useMemo, useRef, useState} from "react";
import SiteContext from "../../store/siteContext";
import SiteService from "../../services/SiteService";
import ArticleImageCarousel from "./rendered/ArticleImageCarousel";
import VideoPlayer from "../ui/VideoPlayer";
import ErrorFallBack from "../ErrorFallBack";
import {ErrorBoundary} from "react-error-boundary";
import FadeIn from "../ui/FadeIn";
import AdvertBlock6 from "../frontpage/content-blocks/AdvertBlock6";
import ContentBlock2 from "../frontpage/content-blocks/ContentBlock2";
import Helpers from "../../helpers/Helpers";
import ContentBlock1 from "../frontpage/content-blocks/ContentBlock1";
import siteService from "../../services/SiteService";
import {Helmet} from "react-helmet";
import TagsContainer from "../ui/TagsContainer";
import CategoriesContainer from "../ui/CategoriesContainer";
import ChronicleIcon from "../../svg/ChronicleIcon";
import CalendarIcon from "../../svg/CalendarIcon";
import AuthorIcon from "../../svg/AuthorIcon";
import FacebookComments from "../FacebookComments";
import UserContext from "../../store/userContext";
import Loginbox from "../ui/functional/Loginbox";
import SeilasArticleBottomAdvert from "../../seilas/SeilasArticleBottomAdvert";
import NativeAdScrollerCampaign from "../NativeAdScrollerCampaign";
import LesSjoenForAlleMagasin from "../LesSjoenForAlleMagasin";
import KampanjeTilbud from "../ui/KampanjeTilbud";

export default function ArticleRenderer({article, isPluss, loadedAuthor}) {
	const siteContext = useContext(SiteContext);
	const isLoggedIn = useContext(UserContext).isLoggedIn;

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [article]);

	const [bannerAdState, setBannerAdState] = useState(null);

	let imageSrc = null;
	if (article.image && article.image.url) {
		let headersWithWideImg = [1,2,5,6,7];
		if (window.innerWidth < 768 && (headersWithWideImg.indexOf(article.headerType) === -1)) {
			imageSrc = ArticleService.getUrlHeaderImage(article).replace('header', 'header-medium');
		}
		else imageSrc = ArticleService.getUrlHeaderImage(article);
	}

	// article.date is in YYYY-MM-DD format. Make displayDate be that but DD.MM.YYYY
	let displayDate = null;
	if (article.date)
		displayDate = article.date.substring(0,10).split('-').reverse().join('.');

	// prepare Related articles
	if (article.relatedArticles && article.relatedArticles.length > 0)
		for (let i = 0; i < article.relatedArticles.length; i++){
			if (article.relatedArticles[i] && typeof article.relatedArticles[i] === 'object')
				Helpers.prepareArticleForFrontpageParts(article.relatedArticles[i], siteContext.categories);
		}

	// prepare Latest news articles
	if (article.newsArticles && article.newsArticles.length > 0)
		for (let i = 0; i < article.newsArticles.length; i++){
			if (article.newsArticles[i] && typeof article.newsArticles[i] === 'object')
				Helpers.prepareArticleForFrontpageParts(article.newsArticles[i], siteContext.categories);
		}

	// prepare Random articles
	if (article.randomArticles && article.randomArticles.length > 0)
		for (let i = 0; i < article.randomArticles.length; i++){
			if (article.randomArticles[i] && typeof article.randomArticles[i] === 'object')
				Helpers.prepareArticleForFrontpageParts(article.randomArticles[i], siteContext.categories);
		}

	useEffect(()=>{
	// add CSS SPONSOR color variables
		if (article.sponsor) {
			if (article.sponsor.color1)
				document.documentElement.style.setProperty('--sponsorColor1', article.sponsor.color1);
			else
				document.documentElement.style.removeProperty('--sponsorColor1');

			if (article.sponsor.color2)
				document.documentElement.style.setProperty('--sponsorColor2', article.sponsor.color2);
			else
				document.documentElement.style.removeProperty('--sponsorColor2');

			if (article.sponsor.color3)
				document.documentElement.style.setProperty('--sponsorColor3', article.sponsor.color3);
			else
				document.documentElement.style.removeProperty('--sponsorColor3');
		}
		// Cleanup function to remove the CSS variable when component unmounts
		return () => {
			document.documentElement.style.removeProperty('--sponsorColor1');
			document.documentElement.style.removeProperty('--sponsorColor2');
			document.documentElement.style.removeProperty('--sponsorColor3');
		};
	}, [article]);


	function ArticleDate() {return(
		<div className={'articleDateContainer'}>
			<CalendarIcon width={'20px'}/>
			<time itemProp={"datePublished"} className={'date'}
				  dateTime={article.date && article.date.substring(0, 10)}>
				{' ' + displayDate}
			</time>
		</div>
	)}


	function LoginRequiredSection(){
		return <div className={'loginRequiredSectionContainer'}><div className={'loginRequiredSection'}>
			<div className={'section'}>
			<h2>Opprett bruker og les artikkelen gratis</h2>
			</div>
				<ul>
					<li>Lagre artikler i favoritter</li>
					<li>Følg dine favorittemaer og få varslinger</li>
					<li>Les utvalgte artikler helt gratis</li>
				</ul>
			<div className={'section flex-column'}>
				<Loginbox sendToRefreshBool={true} removeTitleSection={true}/>
			</div>
		</div></div>
	}

	function HeaderAuthorDateSection() {
		if (article.isSponsored) return null;
		return(<div className={'headerAuthorDateSection'}>
			{loadedAuthor ? <>
				{loadedAuthor.imageName &&
					<img className={'articleAuthorImage'} src={AuthorService.getAuthorImage(loadedAuthor)}/>}
					<div className={'articleAuthorIconAndName'}>
						<AuthorIcon style={{marginTop:'-7px'}} width={'12px'}/>
						<span rel={"author"} itemProp={"author"}>{loadedAuthor.name && loadedAuthor.name}</span>
					</div>
			</>
				: <><img className={'articleAuthorImage'}/> Forfatter: Eksempel</>
			}

			<ArticleDate/>
		</div>)}


	function AnnonseInnholdHeader(){
		return <div className={'annonseinnholdHeader'}>
			<div>ANNONSØRINNHOLD{article.sponsor&&<> AV <b>{article.sponsor?.name?.toUpperCase()}</b></>}</div>
		</div>
	}

	function SponsorLogo() {
		if (!(article.isSponsored && article.sponsor && article.sponsor.logoImage)) return null;

		return (<>{
			article.sponsor.url ?
				<a href={article.sponsor.url ? article.sponsor.url : null} className={'articleSponsorImage'}
				   target={'_blank'}>
					<img
						src={`${siteService.apiPath}/image/sponsors/${article.sponsor._id}${article.sponsor.logoImage}`}
						alt={article.sponsor.name + ' logo'}/>
				</a> :
				<a href={article.sponsor.url ? article.sponsor.url : null} className={'articleSponsorImage'}
				   target={'_blank'}>
					<img
						src={`${siteService.apiPath}/image/sponsors/${article.sponsor._id}${article.sponsor.logoImage}`}
						alt={article.sponsor.name + ' logo'}/>
				</a>
		}</>)
	}

	function IntroBlock() {
		if (!article.intro) return;
		return (
			<div className={'introBlock'}>
				<p className={'introText'}>
					{article.intro}
				</p>
				<div className={'articleAside'}>
					<SponsorLogo/>
					<div className={'articleInteractions'}>
						<FavouriteButton articleId={article._id} addText={true}></FavouriteButton>
						<ShareButton articleTitle={article.name} articleId={article._id} addText={true}/>
					</div>
					<div className={'divider'}></div>
					<CategoriesContainer max={2} categories={article.categories}/>
				</div>
			</div>
		)
	}

	function BannerAdvert(){
		if (article.isSponsored) return null;
		let adPlacementId = null;
		switch (siteService.appName) {
			case 'storbatmagasinet':
				adPlacementId='67d96550007ad1524e9d7661'
				break;
			case 'seilas':
				adPlacementId='67dad66a007ad1524e9ea050'
				break;
			default:
				adPlacementId='000000000000000000000003'
		}
		return <AdvertBlock6 parts={[{id: adPlacementId}]} adState={bannerAdState} setAdState={setBannerAdState}/>
	}

	function HeaderType11Video(){
		let videoId = article.header?.video;
		try {
			if(videoId.includes('youtu.be/')){
				videoId = videoId.split('.be/')[1];
			}else{
				videoId = videoId.split('?v=')[1].split('&')[0].split('?')[0];
			}
		}catch (e){console.error(e)}
		return(<>
			<div>
				<BannerAdvert/>
				<div style={{width:'980px'}} className={['youtubeEmbedContainer'].join(' ')}>
					<iframe id="youtube-1905" allowFullScreen="1"
							allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							src={"https://www.youtube-nocookie.com/embed/" + videoId + "?" + 'mute=0&autoplay=0&amp;controls=1' + "&amp;disablekb=1&amp;playsinline=1&amp;cc_load_policy=0&amp;cc_lang_pref=auto&amp;widget_referrer=https%3A%2F%2Fb-v.no%2Fad%2Fsunseeker-superhawk-55%2F%3Fpreview%3Dtrue&amp;noCookie=true&amp;rel=0&amp;showinfo=0&amp;iv_load_policy=3&amp;modestbranding=1&amp;enablejsapi=1&amp;widgetid=1"}
							frameBorder="0"></iframe>
				</div>
			</div>
			<div className={'articleHeaderTextSection'} >
				<p className={'preface'}>{article.preface}</p>
				<h1 className={'articleTitle'}>{article.name&&article.name}</h1>
				<HeaderAuthorDateSection/>
				<IntroBlock/>
			</div>

		</>)
	}

	function HeaderAuthorOpinionPiece({disableDate}) {
		if (!loadedAuthor) return null;
		return (<>
			<div className={'headerAuthorDateSection'}>
				<div className={'headerAuthorDateSectionPart1'}>
					{loadedAuthor.imageName &&
						<img className={'articleAuthorImage'} src={AuthorService.getAuthorImage(loadedAuthor)}/>}
				<div className={'headerAuthorDateSectionPart2'}>
					<div className={'headerAuthor'}><span rel={"author"}
														  itemProp={"author"}>{loadedAuthor.name && loadedAuthor.name}</span>
					</div>
					<div className={'headerAuthorTitle'}>{loadedAuthor.title}</div>
					{!disableDate&&<ArticleDate/>}
				</div>
				</div>

				<div className={'headerOpinionPieceDisclaimer'}>
					<div><ChronicleIcon width={'27px'}/></div>
					<p>Dette er en kronikk skrevet av en utenfor
					Båtens Verdens redaksjon. Den tar
						utgangspunkt i forfatterens egne meninger.
					</p>
					<a href={'https://abo.b-v.no/kronikk/'} target={"_blank"}>> Delta du også</a>
				</div>
			</div>
		</>)
	}

	const HeaderType10OpinionPiece = useMemo(() => {
		return (
			<div className={'headerType7 headerType2'}>
				<div className={'articleFrontImageWrapper headerImageWrapper'}>
					<div className={'headerImageWrapper header7Image'}
						 style={{backgroundImage: 'url("' + (article.headerB64 ? article.headerB64 : imageSrc) + '")'}}
					>
						<img
							alt={(article.image && article.image.alt) && article.image.alt}
							src={article.headerB64 ? article.headerB64 : imageSrc}
							className={'articleFrontImage'}
						/>

						<swiper-container free-mode="true" mousewheel="true" mousewheel-release-on-edges="true"
										  direction="vertical" touch-release-on-edges="true"
										  style={{backgroundImage: 'url("' + (article.headerB64 ? article.headerB64 : imageSrc) + '")'}}
						>
							<swiper-slide>
								<div className={'header7TextWrapper'}>
									<h1 className={'articleTitle'}>
										<div>DEBATT</div>
										<span>“</span>
										{article.name && article.name}
										<span>“</span>
									</h1>
								</div>
							</swiper-slide>
							<swiper-slide>
								<div className={'header10PrefaceContainer'}>
									<div>“</div>
									<p>{article.preface}</p>
								</div>
							</swiper-slide>
						</swiper-container>

					</div>
				</div>


				{(article.image && article.image.alt) &&
					<p className={'headerImageText'}>{article.image.alt}</p>
				}

				<div className={'articleHeaderTextSection'} >
					<HeaderAuthorOpinionPiece/>
					<BannerAdvert/>
					<IntroBlock/>
				</div>
			</div>
		)
	})

	const HeaderType7 = useMemo(() => {
		if (!article.headerParts || article.headerParts.length < 1) return;

		return (
			<div className={'headerType7 headerType2'}>
				<div className={'articleFrontImageWrapper headerImageWrapper'}>
					<div className={'headerImageWrapper header7Image'}
						 style={{backgroundImage: 'url("' + (article.headerB64 ? article.headerB64 : imageSrc) + '")'}}
					>
						<img
							alt={(article.image && article.image.alt) && article.image.alt}
							src={article.headerB64 ? article.headerB64 : imageSrc}
							className={'articleFrontImage'}
						/>

						<swiper-container free-mode="true" mousewheel="true" mousewheel-release-on-edges="true"
										  direction="vertical" touch-release-on-edges="true"
										  style={{backgroundImage: 'url("' + (article.headerB64 ? article.headerB64 : imageSrc) + '")'}}
						>
							<swiper-slide>
								<div className={'header7TextWrapper'}>
									<h1 className={'articleTitle'}>{article.name && article.name}</h1>
								</div>
							</swiper-slide>
							{article.headerParts.map((part, i) => {
								return <swiper-slide key={i}>
									<p>{part.text}</p>
								</swiper-slide>
							})}
						</swiper-container>

					</div>
				</div>


				{(article.image && article.image.alt) &&
					<p className={'headerImageText'}>{article.image.alt}</p>
				}

				<div className={'articleHeaderTextSection'} >
					<p className={'preface'}>{article.preface}</p>
					<HeaderAuthorDateSection/>
					<BannerAdvert/>
					<IntroBlock/>
				</div>
			</div>
		)
	})


	function HeaderType6() {
		let title = article.name ? article.name.split(' ') : [];
		let preface = article.preface ? article.preface.split(' ') : [];
		let emphasizedStart = article.titleEmphasis ? article.titleEmphasis[0] : null;
		let emphasizedEnd = article.titleEmphasis ? article.titleEmphasis[1] : null;
		let emphasizePrefaceStart = article.prefaceEmphasis ? article.prefaceEmphasis[0] : null;
		let emphasizePrefaceEnd = article.prefaceEmphasis ? article.prefaceEmphasis[1] : null;

		const titleRef = useRef(null);
		const prefaceRef = useRef(null);

		useEffect(() => {
			function fadeOutOnScroll(element) {
				if (!element) {
					console.log('Element not found');
					return;
				}

				var elementHeight = element.offsetHeight;
				var scrollTop = document.documentElement.scrollTop;
				var opacity = 1;

				if (scrollTop > 0) {
					opacity = 1 - ((scrollTop - (window.innerHeight / 2.6))) / (elementHeight);
					if (opacity < 0.1)
						opacity = 0;
				}

				element.style.opacity = opacity;
			}

			function scrollHandler() {
				try {
					fadeOutOnScroll(titleRef.current.parentNode);
				}catch (e) {}
			}

			window.addEventListener('scroll', scrollHandler);
			return () => {
				window.removeEventListener('scroll', scrollHandler);
			};

		},[]);

		function TitleEmhpasis() {return (
			<h1 ref={titleRef} className={'articleTitle'}>
          		<span>
				{title.map((word, index) => {
					if (emphasizedStart !== null && index >= emphasizedStart && index + 1 <= emphasizedEnd) {
						return <span key={index} className={'articleTitleEmphasis'}>{word} </span>;
					} else {
						return <span key={index}>{word} </span>;
					}
				})}
				</span>
			</h1>
		)}

		function PrefaceEmphasis(){return(
			<p ref={prefaceRef}><FadeIn threshold={0.3}>{preface.map((word, index) => {
				if (emphasizePrefaceStart !== null && index >= emphasizePrefaceStart && index + 1 <= emphasizePrefaceEnd) {
					return <span key={index} className={'articleTitleEmphasis'}>{word} </span>;
				} else {
					return <span key={index}>{word} </span>;
				}
			})}</FadeIn></p>
		)}

		return (
			<div className={'headerType2'}>
				<div className={'articleFrontImageWrapper headerImageWrapper'}>
					<div className={'headerImageWrapper header6Image'} style={{backgroundImage:'url("'+(article.headerB64 ? article.headerB64 : imageSrc)+'")'}}>
						<img
							alt={(article.image && article.image.alt) && article.image.alt}
							src={article.headerB64 ? article.headerB64 : imageSrc}
							className={'articleFrontImage'}
						/>
						<div className={'header6TextWrapper'}><TitleEmhpasis/></div>
					</div>
				</div>

				{(article.image && article.image.alt) &&
					<p className={'headerImageText'}>{article.image.alt}</p>
				}

				<div className={'articleHeaderTextSection'} >
					<p className={'preface'}>{article.preface}</p>
					<HeaderAuthorDateSection/>
					<BannerAdvert/>
					<IntroBlock/>
				</div>
			</div>
		);
	}

	function HeaderType4(){return <>
		<CategoriesContainer max={2} categories={article.categories}/>
		<h1 className={'articleTitle'}>{article.name}</h1>

		<div className={'articleHeaderTextSection'} >
			<p className={'preface'}>{article.preface}</p>
			<div className={'interactionsContainer'}>
				<SponsorLogo/>
				<HeaderAuthorDateSection/>
				<div className={'interactionsContainer interactionsContainerInner'}>
				<FavouriteButton articleId={article._id} addText={true}></FavouriteButton>
				<ShareButton articleTitle={article.name} articleId={article._id} addText={true}/>
				</div>
			</div>
		</div>

		<div className={'articleFrontImageWrapper headerImageWrapper'}>
			<img alt={(article.image && article.image.alt) && article.image.alt}
				 src={article.headerB64 ? article.headerB64 : imageSrc}
				 className={'articleFrontImage'}/>
		</div>
		{(article.image && article.image.alt) &&
			<p className={'headerImageText'}>{article.image.alt}</p>
		}
		<BannerAdvert/>
		<p className={'introText'}>
			{article.intro}
		</p>
	</>
	}

	const HeaderType3 = useMemo(() => {
		let localHeaderImage = structuredClone(article.image);
		localHeaderImage.value = localHeaderImage.url;

		return <>
			<div className={'articleHeaderTextSection'} >
				<CategoriesContainer max={2} categories={article.categories}/>
				<h1 className={'articleTitle'}>{article.name}</h1>
				<p className={'preface'}>{article.preface}</p>
				<HeaderAuthorDateSection/>
			</div>

			<ArticleImageCarousel images={[localHeaderImage, ...article.headerImages]} article={article}/>
			<SponsorLogo/>
			<div className={'interactionsContainer'}>
				<FavouriteButton articleId={article._id} addText={true}></FavouriteButton>
				<ShareButton articleTitle={article.name} articleId={article._id} addText={true}/>
			</div>

			<BannerAdvert/>
			<p className={'introText'}>
				{article.intro}
			</p>
		</>
	})

	function HeaderType2() {
		return <>
			<div className={'articleFrontImageWrapper'}>
				<img alt={(article.image && article.image.alt) && article.image.alt}
					 src={article.headerB64 ? article.headerB64 : imageSrc}
					 className={'articleFrontImage'}/>
				{!!(article.headerType && article.headerType === 2) &&
					<h1 className={'articleTitle'}>{article.name}</h1>}
			</div>

			{(article.headerImages && article.headerImages.length > 0) && <>
				{article.headerImages.map((img, i) => {
					const pRef = useRef(null);
					return <div key={i} className={'headerImageWrapper'}>
						{img.type=='video' ?
							<VideoPlayer className={'articleFrontImage'} disableControls={true} videoId={img.video} autoPlay={true}/>
							:
							<img key={i}
								 style={img.desc?{}:{filter:'none'}}
								 alt={(img && img.alt) && img.alt}
								 src={(img.value && img.value.startsWith('data:image')) ? img.value : `${SiteService.apiPath}/image/articles/${article._id}/` + img.value}
								 className={'articleFrontImage'}
							/>
						}
						{img.desc && <FadeIn fadeType={'2'} propRef={pRef}><p ref={pRef} style={img.textboxStyle?img.textboxStyle:null}>{img.desc}</p></FadeIn>}
					</div>
				})}</>
			}

			<div className={'articleHeaderTextSection'} >
				<p className={'preface'}>{article.preface}</p>
				<HeaderAuthorDateSection/>
				<BannerAdvert/>
				<IntroBlock/>
			</div>
	</>
	}

	function HeaderType1() {return <>
			<div className={'articleFrontImageWrapper headerImageWrapper'}>
				<img alt={(article.image && article.image.alt) && article.image.alt}
					 src={article.headerB64 ? article.headerB64 : imageSrc}
					 className={'articleFrontImage'}/>
					<h1 className={'articleTitle'}>
						<span>{article.name}</span>
					</h1>
			</div>

			{(article.image && article.image.alt) &&
				<p className={'headerImageText'}>{article.image.alt}</p>
			}

			<div className={'articleHeaderTextSection'} >
				<p className={'preface'}>{article.preface}</p>
			<HeaderAuthorDateSection/>
			<BannerAdvert/>
			<IntroBlock/>
		</div>
	</>
	}

	function HeaderType0() {return <>
		<div className={'articleFrontImageWrapper headerImageWrapper'}>
			<img alt={(article.image && article.image.alt) && article.image.alt}
				 src={article.headerB64 ? article.headerB64 : imageSrc}
				 className={'articleFrontImage'}/>
		</div>

		{(article.image && article.image.alt) &&
			<p className={'headerImageText'}>{article.image.alt}</p>
		}

		<div className={'articleHeaderTextSection'} >
			<h1 className={'articleTitle'}>{article.name}</h1>
			<p className={'preface'}>{article.preface}</p>
		<HeaderAuthorDateSection/>
		<BannerAdvert/>
		<IntroBlock/>
	</div>
	</>}


	return <>
		<Helmet>
			<title>{article.name}</title>
			<link rel="canonical" href={`${siteService.path}/artikler/${article.urlString}`}/>
			<script type="application/ld+json">
				{`[
				{
				"@context": "http://schema.org",
				"@type": "WebSite",
				"name": "Båtens Verden",
				"url": "https://b-v.no"
    		},
            {
              "@context": "https://schema.org",
              "@type": "${(article.categories?.includes('65fda96301653835b4c685cd')
							|| article.categories?.includes('65f45e04763b05bd1caa3b2a')
				)? 'NewsArticle' : 'Article'}",
              "headline": "${article.name?.replaceAll('"', '')}",
              "image": "${siteService.apiPath}/image/articles/${article._id ? article._id : ""}/header.webp",
              "datePublished": "${article.date ? article.date : ""}",
              "dateModified": "${article.editedDate	 ? article.editedDate : ""}",
              "author": {
                "@type": "Person",
                "name": "${loadedAuthor ? loadedAuthor.name : ""}"
              },
              "availableLanguage": [
					{
						"@type": "Language",
						"alternateName": "nb-NO"
					}
				],
              "publisher": {
                "@type": "Organization",
                "name": "Båtens Verden",
                "logo": {
                  "@type": "ImageObject",
                  "url": "${SiteService.path}/favicon.png"
                }
              },
              "url": "${siteService.path}/artikkel/${article.urlString}",
              "description": "${article.preface?.replaceAll('"', '')}",
              "keywords": "${article.tags?.filter(tag => !tag.hidden).map(tag => tag.name).join(', ')}"
            }
          ]`}
			</script>
		</Helmet>
		<div
			className={['fade-in' ,'articleContainer', article.isSponsored ? 'sponsored' : '', article.isOpinionPiece ? 'opinionPiece' : '', (article.theme && article.theme == 1) ? 'article-dark' : ''].join(' ')}>
			<article className={['articleArticle', isPluss ? "blurred" : ""].join(' ')}>
				{article.isSponsored && <AnnonseInnholdHeader/>}
				<div
					className={['articleHeaderSection', (article.headerType) ? 'headerType' + article.headerType : ''].join(' ')}>
					{!!(!article.headerType || article.headerType === 0) && <HeaderType0/>}
					{!!(article.headerType && article.headerType === 1) && <HeaderType1/>}
					{!!(article.headerType && article.headerType === 5) && <HeaderType1/>}
					{!!(article.headerType && article.headerType === 2) && <HeaderType2/>}
					{!!(article.headerType && article.headerType === 3) && HeaderType3}
					{!!(article.headerType && article.headerType === 4) && <HeaderType4/>}
					{!!(article.headerType && article.headerType === 6) && <HeaderType6/>}
					{!!(article.headerType && article.headerType === 7) && HeaderType7}
					{!!(article.headerType && article.headerType === 8) && <HeaderType0/>}
					{!!(article.headerType && article.headerType === 9) && <HeaderType4/>}
					{!!(article.headerType && article.headerType === 10) && HeaderType10OpinionPiece}
					{!!(article.headerType && article.headerType === 11) && <HeaderType11Video/>}
				</div>

				{(article.isLoginRequired && !isLoggedIn) ? <>
						<LoginRequiredSection/>
					</>
					:
					<div id='bodyPartsContainer' className={'bodyPartsContainer'}>
						<ErrorBoundary FallbackComponent={ErrorFallBack}>{article.bodyParts &&
							<RenderBodyParts article={article} parts={article.bodyParts} loadedAuthor={loadedAuthor}/>
						}
						</ErrorBoundary>
					</div>
				}

				{article.isSponsored && <div className={'articleSponsorFooter'}>
					Annonsørinnholdet er produsert av VB Media AS. Båtens Verdens redaksjon har ingen rolle i
					publiseringen av dette innholdet.
				</div>}

				{article.isOpinionPiece && <div className={'headerType10 headerAuthorDateSection'} style={{
					padding: '1em',
					margin: '1em',
					marginBottom: '4em',
					width: '100%',
					maxWidth: '95vw',
					display: 'flex',
					justifyContent: 'center'
				}}><HeaderAuthorOpinionPiece disableDate={true}/></div>}

				{(article.tags && article.tags.length > 0) && (
					<TagsContainer tags={article.tags}/>
				)}


			</article>

			{(article.categories&&article.tags.some((tag)=>tag.name==="Sjøen for Alle 2025"))&&<>
				<LesSjoenForAlleMagasin/>
				<NativeAdScrollerCampaign/>
			</>}

			{article.isOpinionPiece && <FacebookComments/>}

			{(!(article.categories&&article.tags.some((tag)=>tag.name==="Sjøen for Alle 2025")) && (!article.isSponsored)) && <FadeIn>
				<KampanjeTilbud/>
			</FadeIn>}

			{(article.canonicalDomainApp&&article.canonicalDomainApp==="seilas")&&<SeilasArticleBottomAdvert/>}

			{
				!article.isSponsored && <div className={'articleFooter frontpage'}>
					{(article.relatedArticles && article.relatedArticles.length > 0) &&
						<ContentBlock2 parts={article.relatedArticles} sectionTitle={'Relaterte artikler'}/>}
					{(article.newsArticles && article.newsArticles.length > 0) &&
						<ContentBlock2 slidesPerView={3} parts={article.newsArticles.map((a)=>{
							if (siteService.appName!=='batens_verden'){
								a.linkTo =  'https://b-v.no'+a.linkTo
							}
							return a;})}
							sectionTitle={siteService.appName!=='batens_verden'?'Siste nytt fra Båtens Verden':'Siste nytt'}
						   link={siteService.appName!=='batens_verden'?{link:'https://b-v.no',text:'Til B-V.no'}:{link: '/', text: 'Til forsiden'}}
						   linkContentBlockNewtab={true}
						/>
					}
					{siteService.appName==='batens_verden'&&<>{(article.randomArticles && article.randomArticles.length > 2) &&
						<ContentBlock1 parts={article.randomArticles.slice(0, 3)} sectionTitle={'Fra arkivet'}
									   reverse={true}/>}
					{(article.randomArticles && article.randomArticles.length > 0) &&
						<ContentBlock2 parts={article.randomArticles.slice(3)}/>}</>}
				</div>}
		</div>
	</>
}